// extracted by mini-css-extract-plugin
module.exports = {"container":"AddSchool_container__21KvQ"};